export interface RRIUploadSettings {
  type:
    | 'uploadAll'
    | 'uploadFile'
    | 'cancel'
    | 'cancelAll'
    | 'remove'
    | 'removeAll';
  url?: string;
  method?: string;
  id?: string;
  fieldName?: string;
  data?: {
    [key: string]: string | Blob;
  };
  headers?: {
    [key: string]: string;
  };
  includeWebKitFormBoundary?: boolean;
  withCredentials?: boolean;
}
